import { COJP_SITE, QUICKTAKE_SITE } from "../constants/Sites";
const NETWORK_ID = "5262";

const BLOOMBERG_COMSCORE_SITE = "bloomberg";
interface SiteConfig {
    vertical: string;
    comscore_ns_site: string;
    use_share_overlay: boolean;
    useTranscriptPlugin: boolean;
    useCustomBufferingAnimation?: boolean;
    useContentOverlayPlugin?: boolean;
    use_title_bar?: boolean;
}
const SITE_CONFIG_MAP: Record<string, SiteConfig> = {
    [COJP_SITE]: {
        vertical: "japan",
        comscore_ns_site: "bloomberg-jp",
        use_share_overlay: false,
        useTranscriptPlugin: false,
    },
    [QUICKTAKE_SITE]: {
        vertical: "quicktake",
        comscore_ns_site: BLOOMBERG_COMSCORE_SITE,
        use_share_overlay: true,
        useTranscriptPlugin: false,
        useCustomBufferingAnimation: false,
        useContentOverlayPlugin: true,
        use_title_bar: false,
    },
    default: {
        vertical: "business",
        comscore_ns_site: BLOOMBERG_COMSCORE_SITE,
        use_share_overlay: true,
        useTranscriptPlugin: true,
    },
};

interface Options {
    bmmrId: string;
    playerId: string;
    canonicalUrl: string;
    autoplay: boolean;
    serviceEnv: string;
    continuousPlayPreviousUrl?: string;
    title?: string;
    poster?: string;
    analyticsParams?: object;
    duration?: number;
    site?: string;
    location?: string;
}
export default function generateEmbedOptions({
    bmmrId,
    playerId,
    canonicalUrl,
    autoplay,
    serviceEnv,
    continuousPlayPreviousUrl,
    title,
    poster,
    analyticsParams,
    duration,
    site,
    location = "vid",
}: Options) {
    const customParams = `ni=&autoplay=${autoplay}&suid=${bmmrId}&location=${location}&template=video`;
    const siteConfig =
        site && SITE_CONFIG_MAP[site]
            ? SITE_CONFIG_MAP[site]
            : SITE_CONFIG_MAP.default;
    const { vertical } = siteConfig;

    const options = {
        ...siteConfig,
        autoplay,
        title,
        poster,
        continuous_play_previous_url: undefined as string | undefined,
        video_autoplay_on_page: autoplay,
        htmlChildId: playerId + "-child",
        ad_tag_gpt_preroll: true,
        ad_tag_gpt_midroll: true,
        ad_tag_sz_preroll: "1x7",
        ad_tag_sz_midroll: "1x7",
        ad_tag_midroll: `${vertical}/midroll/vod`,
        ad_network_id_preroll: NETWORK_ID,
        ad_network_id_midroll: NETWORK_ID,
        ad_tag_cust_params_preroll: customParams,
        ad_tag_cust_params_midroll: customParams,
        ad_companion: false,
        log_debug: false,
        share_metadata: {
            canonical_url: canonicalUrl,
        },
        use_google_tag_manager: true,
        id: bmmrId,
        zone: "video",
        useRegUIPopUpPlugin: true,
        analyticsParams,
        duration,
        serviceEnv,
    };

    if (continuousPlayPreviousUrl) {
        options.continuous_play_previous_url = continuousPlayPreviousUrl;
    }

    return options;
}
